import { jwtDecode } from "jwt-decode";
import { TokenResponseType } from "../types/TokenResponse";
import { AUTH_LOCALSTORAGE } from "./constants";

export const isTokenValid = (): boolean => {
  const token = localStorage.getItem(AUTH_LOCALSTORAGE);
  if (!token) {
    return false;
  }
  try {
    const decoded = jwtDecode<TokenResponseType>(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    return false;
  }
};